import { format } from "date-fns";
import { Machine } from "../models/Machine";
import { MachineData } from "../models/MachineData";
import { formatNumberWithLeadingZeros } from "aw-generic-functions";
import { TableData } from "aw-grid";



const generateFile = (machineAux: Machine) => {
    const data = [];
    data.push(`<BEGIN>;;\n`);
    data.push(`<BL>;1;1;AW;${formatNumberWithLeadingZeros(machineAux.idmachine, 5)};${machineAux.token};${machineAux.name};;;;;;;;;;;<EL>;CRC;\n`);
    data.push(`<END>;;`);

    return new Blob(data, {
        type: 'text/plain'
    });
}

const generateCSVData = (md: MachineData[], titles: string) => {
    const data: string[] = [];
    //Indiquem que esta en UTF-8
    data.push('\uFEFF' + titles)
    md.forEach((s: MachineData) => {
        data.push(`${s.machine.name};${format(new Date(s.datetime), "dd/MM/yyyy")};${format(new Date(s.datetime), "HH:mm")};${s.quality};${s.co2};${s.pm10};${s.temperature};${s.humidity}\n`)
    })

    return new Blob(data, {
        type: 'text/plain'
    });
}

const generateCSVProduction = (md: TableData[], titles: string) => {
    const data: string[] = [];
    data.push('\uFEFF' + titles)
    md.forEach((s: TableData) => {
        data.push(`${s.item[1]};${s.item[2]};${s.item[3]};${s.item[4]};${s.item[5]}\n`)
    })

    return new Blob(data, {
        type: 'text/plain'
    });
}

const downloadFile = (dataBlob: Blob, fileName: string) => {
    const reader = new FileReader();
    // eslint-disable-next-line
    reader.onload = function (event: any) {
        const save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        save.download = fileName;
        const clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
        });
        save.dispatchEvent(clicEvent);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
    };
    reader.readAsDataURL(dataBlob);
};

export { generateFile, downloadFile, generateCSVData, generateCSVProduction }